import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	unresolvedIssuesHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unresolvedIssuesMove: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unresolvedIssuesIgnore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	invalidVersionChosen: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unresolvedIssuesHeaderIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unresolvedIssuesMoveIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unresolvedIssuesIgnoreIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	invalidVersionChosenIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	invalidVersionChosenIssueTermRefreshGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	unresolvedIssuesHeader: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-header',
		defaultMessage: 'Unresolved {issues, plural, one {issue} other {issues}}',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	unresolvedIssuesMove: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-move',
		defaultMessage: 'Move unresolved {issues, plural, one {issue} other {issues}} to',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	unresolvedIssuesIgnore: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-ignore',
		defaultMessage: 'Ignore unresolved issues',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	invalidVersionChosen: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.invalid-version-chosen',
		defaultMessage:
			"Can't use this version. Change this version to another in your project or remove it from {issues, plural, one {this issue} other {these issues}}.",
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	unresolvedIssuesHeaderIssueTermRefresh: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-header-issue-term-refresh',
		defaultMessage: 'Unresolved {issues, plural, one {work item} other {work items}}',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	unresolvedIssuesMoveIssueTermRefresh: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-move-issue-term-refresh',
		defaultMessage: 'Move unresolved {issues, plural, one {work item} other {work items}} to',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	unresolvedIssuesIgnoreIssueTermRefresh: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-ignore-issue-term-refresh',
		defaultMessage: 'Ignore unresolved work items',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	invalidVersionChosenIssueTermRefresh: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.invalid-version-chosen-issue-term-refresh',
		defaultMessage:
			"Can't use this version. Change this version to another in your project or remove it from {issues, plural, one {this work item} other {these work items}}.",
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	invalidVersionChosenIssueTermRefreshGalaxia: {
		id: 'project-directories.versions.release-version-modal.content.swap-issues.invalid-version-chosen-issue-term-refresh-galaxia',
		defaultMessage:
			"Can't use this version. Change this version to another in your space or remove it from {issues, plural, one {this work item} other {these work items}}.",
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
});
export default messages;
